import { readBearerToken } from './grampsAuth';
import { apiGet } from './api/grampsApi';

export const DEFAULT_SITE_TITLE = 'Genealhistory';

type TreeMetadata = {
  id?: string;
  handle?: string;
  name?: string;
  title?: string;
  tree_name?: string;
  tree?: string;
};

function extractTreeName(payload: unknown): string | null {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const metadata = payload as {
    tree?: string;
    active_tree?: string;
    current_tree?: string;
    tree_name?: string;
    title?: string;
    trees?: TreeMetadata[];
    objects?: TreeMetadata[];
    data?: TreeMetadata[];
  };

  const direct = [metadata.tree_name, metadata.title]
    .map((v) => (typeof v === 'string' ? v.trim() : ''))
    .find((v) => v.length > 0);
  if (direct) {
    return direct;
  }

  const currentTreeId = [metadata.active_tree, metadata.current_tree, metadata.tree]
    .map((v) => (typeof v === 'string' ? v.trim() : ''))
    .find((v) => v.length > 0);

  const trees = Array.isArray(metadata.trees)
    ? metadata.trees
    : Array.isArray(metadata.objects)
      ? metadata.objects
      : Array.isArray(metadata.data)
        ? metadata.data
        : [];

  const getTreeLabel = (tree: TreeMetadata): string => {
    const label = [tree.name, tree.title, tree.tree_name, tree.tree]
      .map((v) => (typeof v === 'string' ? v.trim() : ''))
      .find((v) => v.length > 0);
    return label || '';
  };

  if (currentTreeId) {
    const match = trees.find((tree) => {
      const ids = [tree.id, tree.handle, tree.tree]
        .map((v) => (typeof v === 'string' ? v.trim() : ''))
        .filter((v) => v.length > 0);
      return ids.includes(currentTreeId);
    });

    if (match) {
      const label = getTreeLabel(match);
      if (label) {
        return label;
      }
    }
  }

  const firstLabel = trees
    .map(getTreeLabel)
    .find((label) => label.length > 0);

  return firstLabel || null;
}

export async function updateTitleFromCurrentTree(): Promise<void> {
  const token = readBearerToken();
  if (!token) {
    document.title = DEFAULT_SITE_TITLE;
    return;
  }

  try {
    const payload = await apiGet('/api/metadata/', { token });
    if (!payload) {
      document.title = DEFAULT_SITE_TITLE;
      return;
    }
    const treeName = extractTreeName(payload);
    document.title = treeName || DEFAULT_SITE_TITLE;
  } catch {
    document.title = DEFAULT_SITE_TITLE;
  }
}
